module.exports = __webpack_public_path__ + "static/media/defesa.d0bfb9d0.png";